import { type FC } from "react";
import { NamesOfFieldBankInfoEnum, TypeBankInfo } from "~/typings/types";

import styles from "./BankConfirmCard.module.scss";

interface Props {
  bank: TypeBankInfo;
}

export const BankConfirmCard: FC<Props> = ({ bank }) => {
  return (
    <div className={styles.card}>
      <div className={styles.col}>
        <span className={styles.label}>Наименование банка</span>
        <span className={styles.value}>{bank[NamesOfFieldBankInfoEnum.BankName]}</span>
      </div>
      <div className={styles.col}>
        <span className={styles.label}>Корреспондентский счёт</span>
        <span className={styles.value}>{bank[NamesOfFieldBankInfoEnum.BankCorrespondentAccount]}</span>
      </div>
      {/* {bank[NamesOfFieldBankInfoEnum.BankKpp] && (
        <div className={styles.col}>
          <span className={styles.label}>КПП</span>
          <span className={styles.value}>{bank[NamesOfFieldBankInfoEnum.BankKpp]}</span>
        </div>
      )} */}
    </div>
  );
};
